import { fetchCountriesFromBackend } from "./utils.js";

export class CreateForm {
  constructor(id, inputs) {
    this.form = document.createElement("form");
    this.form.setAttribute("id", id);
    this.inputs = inputs;
    this.createDialogFormRow();
  }

  createDialogInput(id, placeholder, type, inputObj) {
    let input;
    if (type == "select") {
      input = document.createElement("select");
      if ("preDefinedSelect" in inputObj) {
        if (inputObj.preDefinedSelect == "country") this.createDialogCountriesList(input);
      } else {
        options = inputObj.options;
        options.forEach(function (option) {
          let optionElement = document.createElement("option");
          optionElement.setAttribute("value", option.value);
          optionElement.innerHTML = option.label;
          input.appendChild(optionElement);
        });
      }
    } else if (type == "stripe") {
      input = document.createElement("div");
      input.setAttribute("id", id);
      input.setAttribute("class", "custom-card-element");

      let img = document.createElement("img");
      img.setAttribute("id", "card-brand-logo");
      img.setAttribute("class", "card-brand-logo");

      input.appendChild(img);

      inputObj.card.mount(input);

      return input;
    } else {
      input = document.createElement("input");
    }
    input.setAttribute("type", type);
    input.setAttribute("id", id);
    input.setAttribute("placeholder", placeholder);
    input.setAttribute("class", "form-control");
    if ("disabled" in inputObj) {
      input.disabled = inputObj.disabled;
    }
    if ("required" in inputObj) {
      input.required = inputObj.required;
    }
    if ("value" in inputObj) {
      input.value = inputObj.value;
    }

    if (id === "license_key") {
      let container = document.createElement("div");
      container.setAttribute("class", "input-group license-input-group");
      container.style.position = "relative";
      container.style.display = "flex";
      container.style.alignItems = "center";
      
      container.appendChild(input);

      let copyIcon = document.createElement("span");
      copyIcon.setAttribute("class", "copy-icon");
      copyIcon.style.position = "absolute";
      copyIcon.style.right = "10px";
      copyIcon.style.cursor = "pointer";
      copyIcon.style.display = "flex";
      copyIcon.style.alignItems = "center";
      copyIcon.style.justifyContent = "center";
      copyIcon.style.color = "#555";

      copyIcon.innerHTML = `
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-copy"><rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path></svg>
      `;

      copyIcon.onclick = function () {
          navigator.clipboard.writeText(input.value);
          frappe.show_alert({
              title: __('Copied!'),
              message: __('API Key has been copied to clipboard.'),
              indicator: 'green'
          });
      };
      container.appendChild(copyIcon);

      return container;
    }

    return input;
  }

  createDialogInputLabel(id, placeholder, inputObj) {
    let label = document.createElement("label");
    label.setAttribute("for", id);
    label.innerHTML = placeholder;
    if ("required" in inputObj) {
      label.innerHTML = `<span class="required">*</span> ${placeholder}`;
    }
    return label;
  }

  createDialogFormGroup(colWidth, input) {
    let formGroupDiv = document.createElement("div");
    formGroupDiv.setAttribute("class", `form-group col-md-${colWidth}`);
    let label = this.createDialogInputLabel(input.id, input.label, input);
    let inputField = this.createDialogInput(input.id, input.label, input.type, input);
    formGroupDiv.appendChild(label);
    formGroupDiv.appendChild(inputField);
    if (input.type == "stripe") {
      let errorDetails = document.createElement("p");
      errorDetails.setAttribute("id", "card-errors");
      formGroupDiv.appendChild(errorDetails);
    }
    return formGroupDiv;
  }

  async createDialogFormRow() {
    this.inputs.forEach((row) => {
      let formRowDiv = document.createElement("div");
      formRowDiv.setAttribute("class", "form-row");
      row[1].forEach((input) => {
        let formGroup = this.createDialogFormGroup(row[0], input);
        formRowDiv.appendChild(formGroup);
      });
      this.form.appendChild(formRowDiv);
    });
  }

  async createDialogCountriesList(input) {
    const countries = await fetchCountriesFromBackend();
    countries.forEach((country) => {
      const option = document.createElement("option");
      option.value = country.code;
      option.textContent = country.name;
      input.appendChild(option);
    });
  }
}
